module.exports = __webpack_public_path__ + "img/logo-lk.c0e51f57.png";